import { CHECKOUT_SHIPPING_HANDLED_ERROR } from "@iewccouk/Store/Handlers/CheckoutShipping/CarrierAddressError";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DisplayError } from "@insite/client-framework/Store/Context/Handlers/HandleError";

/**
 * IEIXOP-6930: Only suppress the generic Unhandled Error modal when Checkout Shipping
 * explicitly marked the error (carrier rating failure). Do not suppress "No carriers"
 * failures from other pages so their existing error handling is unchanged.
 */
replaceInChain(chain, DisplayError, props => {
    const error = props.parameter.error as { [CHECKOUT_SHIPPING_HANDLED_ERROR]?: boolean } | undefined;
    if (error?.[CHECKOUT_SHIPPING_HANDLED_ERROR]) {
        return;
    }

    return DisplayError(props);
});
